import { baseThemeData } from "./baseTheme";

const baseDefaultThemeData = {
  ...baseThemeData
};

const computePanelThemeData = () => {
  return {
    panel: {
      header: {
        icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
        title: {
          defaultColor: baseDefaultThemeData.textColor
        },
        description: {
          defaultColor: baseDefaultThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeExpandablePanelThemeData = () => {
  return {
    expandablePanel: {
      before: {
        borderTopColor: "#2c2c2c",
        boxShadow: "0px -1px 0px 0px",
        boxShadowColor: "#171717"
      },
      header: {
        icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
        title: {
          defaultColor: baseDefaultThemeData.textColor,
          expandedColor: baseDefaultThemeData.colors.brandColor
        },
        arrow: {
          defaultColor: baseDefaultThemeData.textColor,
          expandedColor: baseDefaultThemeData.colors.brandColor
        }
      }
    }
  };
};

const computeListThemeData = () => {
  return {
    list: {
      item: {
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c",
        text: { defaultColor: "#cccccc" },
        checkbox: {
          checkedBackground: baseDefaultThemeData.colors.brandColor,
          unCheckedBackground: "#000000",
          defaultColor: "#000000"
        }
      }
    }
  };
};

const computeCheckboxListThemeData = () => {
  return {
    checkboxList: {
      title: {
        defaultColor: "#cccccc",
        borderBottomColor: "rgb(23, 23, 23)",
        boxShadow: "0px 1px 0px 0px",
        boxShadowColor: "#2c2c2c"
      }
    }
  };
};

const computeDrawerThemeData = () => {
  return {
    drawer: {
      header: {
        backgroundColor: "#0a0a0a"
      },
      area: { background: baseDefaultThemeData.backgrounds.mainBG },
      box: { background: baseDefaultThemeData.backgrounds.boxBG }
    }
  };
};

const getHeaderButtonPcStyles = () => {
  return {
    ...baseThemeData,
    colors: {
      ...baseThemeData.colors,
      textColorBtnOutlined: "#fc6200",
      outlinedBorderColor: "#fc6200"
    },
    typography: {
      ...baseThemeData.typography,
      fontSize: `1.4rem`,
      fontWeight: 900
    },
    backgrounds: {
      ...baseThemeData.backgrounds,
      hoverColorOutlined: baseDefaultThemeData.colors.brandColor
    },
    borders: {
      ...baseThemeData.borders,
      borderColor: baseThemeData.colors.brandColor,
      borderColorMobile: baseThemeData.colors.brandColor
    }
  };
};

const computeLinkButtonThemeData = () => {
  return {
    linkButtonTitle: {
      defaultColor: "#cccccc",
      borderBottomColor: "rgb(23, 23, 23)",
      boxShadow: "0px 1px 0px 0px",
      boxShadowColor: "#2c2c2c"
    },
    linkButton: {
      icon: { defaultColor: baseDefaultThemeData.colors.iconColor },
      title: { defaultColor: baseDefaultThemeData.colors.textColor },
      description: {
        defaultColor: baseDefaultThemeData.colors.brandColor
      },
      arrow: {
        defaultColor: "#ffffff"
      }
    }
  };
};

const computeLinkItemThemeData = () => {
  return {
    linkItem: {
      icon: { defaultColor: baseDefaultThemeData.colors.iconColor }
    }
  };
};

export const DefaultThemeData = {
  getHeaderButtonPcStyles,
  ...baseDefaultThemeData,
  ...computePanelThemeData(),
  ...computeExpandablePanelThemeData(),
  ...computeDrawerThemeData(),
  ...computeListThemeData(),
  ...computeCheckboxListThemeData(),
  ...computeLinkButtonThemeData(),
  ...computeLinkItemThemeData()
};
